import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import MovieCard from "../components/MovieCard";
import { toast } from "sonner";

export default function MyList() {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/favorites");
      setMovies(data);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    try {
      await api.delete(`/favorites/${id}`);
      setMovies(movies.filter((m) => m.id !== id));
      toast.success("Retiré de Ma Liste");
    } catch (err) { console.error(err); }
  };

  return (
    <div className="pt-24 pb-24 max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12">
      <div className="space-y-2 mb-10">
        <div className="font-mono-mini text-[11px] uppercase tracking-[0.4em] text-[color:var(--ns-accent)]">
          Collection personnelle
        </div>
        <h1 className="font-display text-5xl uppercase">Ma Liste</h1>
      </div>
      {loading ? (
        <div className="text-zinc-400">Chargement…</div>
      ) : movies.length === 0 ? (
        <div className="text-zinc-500 text-center py-16">
          Votre liste est vide. Explorez le catalogue et ajoutez vos coups de cœur.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {movies.map((m) => (
            <MovieCard key={m.id} movie={m} inList={true} onToggleList={() => remove(m.id)} />
          ))}
        </div>
      )}
    </div>
  );
}
